import { createStore, applyMiddleware, compose } from "redux";
import createSagaMiddleware from "redux-saga";
import thunk from "redux-thunk";
import reducer from "./reducers";
import dotEnv from "dotenv";
dotEnv.config();

const sagaMiddleware = createSagaMiddleware();

const initialState = {};
const middleware = [thunk];

const composeEnhancers =
  typeof window === "object" && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
    ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
        initialState,
      })
    : compose;

const enhancer = composeEnhancers(applyMiddleware(...middleware));

const store = createStore(
  reducer,
  process.env.REACT_APP_ENV === "production"
    ? applyMiddleware(...middleware)
    : enhancer
);

export default store;

// REACT_APP_ENV
